import React from 'react';
import PropTypes from 'prop-types';
import {Form} from '@evag/ec-react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import CustomHero from 'src/components/CustomHero';
import Peticao from 'src/components/forms/parts/Peticao';
import OAB from 'src/components/forms/parts/OAB';
import Feedback from '../components/forms/parts/Feedback';

import styles from './cassacao.module.scss';
import a from '../components/Article.module.scss';


export default function render({data, location}) {
  return (
    <Layout solidHeader={true}>
      <SEO
        title="CENSURA NUNCA MAIS!"
        description="Movimento de advogados pela democracia para resistir às investidas autoritárias contra cidadãos brasileiros."
        ogimage={{
          src:
            'https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/tudo.png',
          width: '1200',
          height: '600',
        }}
      />

      <CustomHero
        image={{
          alt: 'CENSURA NUNCA MAIS!',
          src:
            'https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/fundo.png',
        }}
        overClassName={styles.over}
      >
        <img
          style={{display: 'block', margin: 'auto'}}
          src="https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/frase.png"
        />
      </CustomHero>

      <main className={styles.container}>
        <div className="wrap">
          <div className={a.wrap}>
            <div className={a.text}>

              <p>
              Somos um movimento de advogados e advogadas pela democracia que pretende resistir às investidas autoritárias contra cidadãos brasileiros, com base nos dispositivos da Lei de Segurança Nacional, entulho autoritário do regime militar.
      
              </p>

              <p>
              A estratégia usada por Bolsonaro é a abertura de processos com base na Lei de Segurança Nacional contra seus críticos em todo território nacional, lideranças políticas, artistas, jornalistas e influenciadores digitais, com o objetivo de amedrontar os críticos e silenciar a oposição.
                
              </p>

              
            </div>
          </div>
        </div>
      </main>

      <div className={styles.form}>
        <div className={a.wrap}>
        <p>
              Se você está sendo ameaçado ou processado pela família Bolsonaro ou membros do governo federal, preencha o formulário abaixo que entraremos em contato com você para te auxiliar.
              </p>

          <Form
            forms={[
              {
                ...Peticao,
                channelId: '1ae5889b-7705-47f7-b3f1-0d95e3c23947',
                btnText: 'Assinar',
              },
              {
                ...Feedback,
                title: 'Censura nunca mais!',
                url: location.href,
                text:
                  'Muito obrigada! Agora ajude a espalhar essa campanha compartilhando nas redes sociais.',
              },
            ]}
          />
        </div>
      </div>

      <main className={styles.container}>
        <div className="wrap">
          <div className={a.wrap}>
            <div className={a.text}>

              <p>
              É hora da advocacia no Brasil inteiro se levantar contra a tentativa do governo Bolsonaro de calar as vozes da oposição. O artigo 5⁰, inciso IX, da Constituição Federal protege a liberdade de expressão como direito inalienável e fundamental.
              
      
              </p>

              <p>
              Para defender o Estado Democrático de Direto e o livre exercício da crítica, é que convocamos todos(as) advogados(as) a fazerem parte do movimento “Censura Nunca Mais”.
              
                
              </p>

              <p>
              Reuniões com todos os advogados(as) cadastrados (as) serão realizadas em todas as regiões do Brasil a fim de organizar e mapear as vítimas dos processos injustos e ilegais movidos pelo clã Bolsonaro.

              </p>

              
            </div>
          </div>
        </div>
      </main>

      <div className={styles.form}>
        <div className={a.wrap}>
        <p>
              Você advogado(a) que tem interesse em participar desse movimento em defesa do Estado Democrático de Direito é muito fácil, preencha o cadastro abaixo, que um advogado(a) participando do movimento da sua região vai entrar em contato.

              </p>

          <Form
            forms={[
              {
                ...OAB,
                channelId: '70503fba-86c5-40e9-ac1e-9e6530eed1dd',
                btnText: 'Assinar',
              },
              {
                ...Feedback,
                title: 'Censura nunca mais!',
                url: location.href,
                text:
                  'Muito obrigada! Agora ajude a espalhar essa campanha compartilhando nas redes sociais.',
              },
            ]}
          />
        </div>
      </div>
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};
